import React from 'react'
import {connect} from 'react-redux'
import {ModalLoading as ModalState} from '../../../redux/reducers/modalLoadingReducer'
import Modal from 'react-bootstrap/Modal'
import {Spinner} from 'react-bootstrap'

type Props = {
  props?: any
  modalLoading?: ModalState
}

const ModalLoading: React.FC<Props> = (props) => {
  return (
    <Modal show={props?.modalLoading?.show ?? false} onHide={() => {}} animation={false} centered aria-labelledby='contained-modal-title-vcenter' size='sm'>
      <Modal.Dialog size='sm' className='p-0'>
        <Modal.Body className='p-0 py-5'>
          <div className='d-flex justify-content-center'>
            <Spinner animation='border' role='status' variant='primary' style={{width: 80, height: 80}}></Spinner>
          </div>
          <p className='mt-5 mb-0 fw-bold fs-4 text-primary text-center'>{props.modalLoading?.text ?? 'Loading'}</p>
        </Modal.Body>
      </Modal.Dialog>
    </Modal>
  )
}

const reduxState = (state: any) => ({
  modalLoading: state.modalLoading,
})

export default connect(reduxState, null)(ModalLoading)
